import { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useInactivityLogout } from './hooks/useInactivityLogout';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import { TempoAtivoProvider } from './components/TempoAtivoContext';
import TempoFlutuante from './components/TempoFlutuante';
import MemoraGuard from './components/MemoraGuard';
import Memora_documentacao from './pages/Memora_documentacao';
import Home from './pages/Home';
import Login from './pages/Login';
import Logout from './pages/Logout';
import PrivateRoute from './routes/PrivateRoute';
import ClienteRoute from './routes/ClienteRoute';
import ModuloRoute from './routes/ModuloRoute';
import Kanban from './pages/Kanban';
import Tarefas from './pages/Tarefas';
import IntegraContador from './pages/IntegraContador';
import Dctfweb from './pages/Dctfweb';
import FiscalGuard from './components/FiscalGuard';
import FiscalBase from './pages/FiscalBase';
import FiscalCertificados from './pages/FiscalCertificados';
import FiscalConfiguracoes from './pages/FiscalConfiguracoes';
import FiscalMonitor from './pages/FiscalMonitor';
import FiscalUsuarios from './pages/FiscalUsuarios';
import FiscalDocumentacao from './pages/FiscalDocumentacao';
import FiscalPainel from './pages/FiscalPainel';
import FiscalFechamento from './pages/FiscalFechamento';
import FiscalConsultaChave from './pages/FiscalConsultaChave';
import FiscalFaturamento from './pages/FiscalFaturamento';
import FiscalEntregas from './pages/FiscalEntregas';
import FiscalTarefas from './pages/FiscalTarefas';
import FiscalTarefasAcessorias from './pages/FiscalTarefasAcessorias';
import FiscalCaixaPostal from './pages/FiscalCaixaPostal';
import FiscalRegime from './pages/FiscalRegime';
import Dividas from './pages/Dividas';
import Das from './pages/Das';
import Enviaremaildp from './pages/Enviaremaildp';
import BpoRhClientes from './pages/BpoRhClientes';
import BpoRhClientesCadastro from './pages/BpoRhClientesCadastro';
import BpoRhAdmissoes from './pages/BpoRhAdmissoes';
import BpoRhAtividadesAdmissao from './pages/BpoRhAtividadesAdmissao';
import BpoTarefasMensais from './pages/BpoTarefasMensais';
import BpoRhRescisoes from './pages/BpoRhRescisoes';
import BpoRhFerias from './pages/BpoRhFerias';
import BpoRhProrrogacao from './pages/BpoRhProrrogacao';
import BpoRhEstagio from './pages/BpoRhEstagio';
import BpoRhColaboradores from './pages/BpoRhColaboradores';
import BpoRhPonto from './pages/BpoRhPonto';
import BpoRhBeneficios from './pages/BpoRhBeneficios';
import BpoRhExamePeriodico from './pages/BpoRhExamePeriodico';
import BpoRhSindicatos from './pages/BpoRhSindicatos';
import BpoRhFolha from './pages/BpoRhFolha';
import BpoRhValeTransporte from './pages/BpoRhValeTransporte';
import FechamentoPonto from './pages/FechamentoPonto';
import BpoRhConversas from './pages/BpoRhConversas';
import PainelOperador from './pages/PainelOperador';
import GestaoBpoRh from './pages/GestaoBpoRh';
import BpoRhFechamentoCliente from './pages/BpoRhFechamentoCliente';
import BpoRhFinanceiro from './pages/BpoRhFinanceiro';
import BpoRhDissidio from './pages/BpoRhDissidio';
import BpoRhAgenteRh from './pages/BpoRhAgenteRh';
import BpoRhCurriculos from './pages/BpoRhCurriculos';
import BpoRhAjusteSalario from './pages/BpoRhAjusteSalario';
import BpoRhImportacaoOmie from './pages/BpoRhImportacaoOmie';
import BpoRhAdiantamento from './pages/BpoRhAdiantamento';
import BpoRhLiquidosCC from './pages/BpoRhLiquidosCC';
import BpoRhControleFolgas from './pages/BpoRhControleFolgas';
import BpoRhPlanoSaude from './pages/BpoRhPlanoSaude';
import BpoRhCustoColaborador from './pages/BpoRhCustoColaborador';
import BpoRhOperadores from './pages/BpoRhOperadores';
import BpoRhDocumentacao from './pages/BpoRhDocumentacao';
import DpAtividade from './pages/DpAtividade';
import Contabilidade from './pages/Contabilidade';
import PortalCliente from './pages/PortalCliente';
import Textolivre from './pages/Textolivre';
import CadastrarCliente from './pages/Cadastrarcliente';  
import RelatorioFiscal from './pages/RelatorioFiscal';
import Pgfn from './pages/Pgfn';
import Fgts from './pages/Fgts';
import Comprovante from './pages/Comprovante';
import Logados from './pages/Logados';
import Checklist from './pages/Checklist';
import Contagemcontabilidade from './pages/Contagemcontabilidade';
import Pendenciacontabil from './pages/Pendenciacontabil';
import PainelOperacionalContabil from './pages/PainelOperacionalContabil';
import Bpo from './pages/Bpo';
import AcessoNegado from './pages/AcessoNegado';
import Outboardingcontabil from './pages/Outboardingcontabil';  
import Relatorio_contabil from './pages/Relatorio_contabil';
import RevisaoRelatorios from './pages/RevisaoRelatorios';
import Gestao_contabil from './pages/Gestao_contabil';
import Atrasoatual from './pages/Atrasoatual';
import Devedores from './pages/Devedores';
import Impostos_recup from './pages/Impostos_recup';
import CarteiraContabil from './pages/CarteiraContabil';
import TermosDeUso from './components/TermosDeUso';
import AtualizacoesModal from './components/AtualizacoesModal';
import ModalAtrasosRh from './components/ModalAtrasosRh';
import ModalFinalizacaoDevolvida from './components/ModalFinalizacaoDevolvida';
import AdminAtualizacoes from './pages/AdminAtualizacoes';
import Admconsultas from './pages/Admconsultas';
import SpedContabil from './pages/SpedContabil';
import GestaoBpo from './pages/GestaoBpo';
import BpoFinConciliacaoOmie from './pages/BpoFinConciliacaoOmie';
import BpoFinCartaoPixCards from './pages/BpoFinCartaoPixCards';
import BpoFinConciliacaoVendizap from './pages/BpoFinConciliacaoVendizap';
import BpoFinConciliacaoAsaasVendizap from './pages/BpoFinConciliacaoAsaasVendizap';
import Reunioes from './pages/Reunioes';
import ListaReunioes from './pages/ListaReunioes';
import ConfiguracaoCalendario from './pages/ConfiguracaoCalendario';
import Auditoria_balancete from './pages/Auditoria_balancete';
import Auditoria_resultado from './pages/Auditoria_resultado';
import Historico_auditoria from './pages/Historico_auditoria';
import HistoricoEnvioLucrosSocios from './pages/HistoricoEnvioLucrosSocios';
import CadastrarUsuario from './pages/CadastrarUsuario';
import AdminLogs from './pages/AdminLogs';
import MemoraContestacoes from './pages/MemoraContestacoes';
import WebhookEventos from './pages/WebhookEventos';
import StripeEventos from './pages/StripeEventos';
import AdminCustosGcp from './pages/AdminCustosGcp';
import CargasBanco from './pages/CargasBanco';
import ApiOcorrencias from './pages/ApiOcorrencias';
import SyncConvenia from './pages/SyncConvenia';
import CopiaBanco from './pages/CopiaBanco';
import RelatorioInvestidores from './pages/RelatorioInvestidores';
import FmpLanding from './pages/FmpLanding';
import SolicitacaoAdmissao from './pages/SolicitacaoAdmissao';
import SolicitacaoDesligamento from './pages/SolicitacaoDesligamento';



// IMPORTAR APENAS AS PÁGINAS UNIFICADAS (com :cliente_id)
import DashboardCliente from './pages/DashboardCliente';
import Apagar_cliente from './pages/Apagar_cliente';
import Receber_cliente from './pages/Receber_cliente';
import Posicao_cliente from './pages/Posicao_cliente';
// Posicao_cliente_conta_azul.js estava VAZIO (rota quebrava ao abrir) — a rota
// antiga agora reaproveita o Posicao_cliente, que já atende Omie e Conta Azul.
import Posicao_dia from './pages/Posicao_dia';
import Fechamento_cliente from './pages/Fechamento_cliente';
import EnvioNotas_cliente from './pages/EnvioNotas_cliente';
import Projetos_cliente from './pages/Projetos_cliente';
import DashboardContaAzul from './pages/DashboardContaAzul';
import AssistenteFinanceiroCliente from './pages/AssistenteFinanceiro_cliente';
import Config_contas_omie from './pages/Config_contas_omie';
import PlanejamentoCliente from './pages/Planejamento_orcamentario';
import SavingCliente from './pages/Saving_cliente';
import DreHorizontal from './pages/Dre_horizontal';
import DreVertical from './pages/Dre_vertical';
import OrcamentoCadastro from './pages/Orcamento_cadastro';
import Contabil_reunioes from './pages/Contabil_reunioes';
import Analise_op_memora from './pages/Analise_op_memora';
import Analise_gestor_memora from './pages/Analise_gestor_memora';
import MemoraAnaliseClientes from './pages/MemoraAnaliseClientes';
import Oportunidades_memora from './pages/Oportunidades_memora';
import Memora_riscos from './pages/Memora_riscos';
import Memora_intelligenc from './pages/Memora_intelligenc';




const getUsuarioLogado = () => {
  try {
    const token = localStorage.getItem('access');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return (payload.first_name || payload.username || '').toLowerCase();
  } catch {
    return null;
  }
};

// Espelho da tabela `cliente_restrito` do backend (quem é barrado de verdade).
// Serve só para desviar a navegação cedo; o bloqueio que vale é o do servidor.
const CLIENTES_RESTRITOS = {
  '19': ['eleandro', 'yasmin', 'machado', 'angelo'],   // Gerencial
  '36': ['eleandro', 'yasmin', 'machado', 'angelo'],   // GERENCIAL (duplicata inativa)
};

const ClienteRestritoRoute = ({ element }) => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const permitidos = CLIENTES_RESTRITOS[String(cliente_id)];
    if (permitidos) {
      const usuario = getUsuarioLogado();
      const temAcesso = usuario && permitidos.some(nome => usuario.includes(nome));
      if (!temAcesso) {
        navigate('/acesso-negado', { replace: true });
      }
    }
  }, [cliente_id, navigate]);

  return element;
};

const LayoutWrapper = ({ children }) => {
  const location = useLocation();

  // Páginas full-bleed: sem sidebar, sem header, sem padding (login, acesso negado, site /fmp)
  const fullBleed = location.pathname === '/login'
    || location.pathname === '/acesso-negado'
    || location.pathname === '/fmp'
    || location.pathname === '/admissao'
    || location.pathname === '/desligamento';

  const isAuthPage = location.pathname !== '/login' && location.pathname !== '/logout';
  const { resetTimer } = useInactivityLogout(260);
  
  useEffect(() => {
    if (isAuthPage) {
      console.log('Sistema de logout por inatividade ativo (260 minutos)');
    }
  }, [isAuthPage]);

  // Rotas que não mostram o Header
  const hideHeaderRoutes = [
    '/login',
    '/logout',
    '/home',
    '/fmp',
    '/admissao',
    '/desligamento',
    '/kanban',
    '/tarefas',
    '/IntegraContador',
    '/Dctfweb',
    '/Dividas',
    '/das',
    '/Enviaremaildp',
    '/BpoRhClientes',
    '/BpoRhClientesCadastro',
    '/BpoRhColaboradores',
    '/BpoRhAtividadesAdmissao',
    '/BpoTarefas/RH',
    '/BpoTarefas/FIN',
    '/BpoFin/ConciliacaoOmie',
    '/BpoFin/CartaoPixCards',
    '/BpoFin/ConciliacaoVendizap',
    '/BpoFin/ConciliacaoAsaasVendizap',
    '/contabilidade',
    '/Textolivre',
    '/Contabilidade',
    '/CadastrarCliente',
    '/relatorio-fiscal',
    '/pgfn',
    '/Guia-fgts',
    '/Comprovante-ECAC',
    '/Logados',
    '/Checklist',
    '/Contagemcontabilidade',
    '/Pendenciacontabil',
    '/Contabilidade/Operacional',
    '/Bpo',
    '/Outboardingcontabil',
    '/Relatorio_contabil',
    '/RevisaoRelatorios',
    '/acesso-negado',
    '/Gestao_contabil',
    '/Atrasoatual',
    '/Devedores',
    '/Impostos-recup',
    '/CarteiraContabil',
    '/termos-de-uso',
    '/Admconsultas',
    '/SpedContabil',
    '/GestaoBpo',
    '/Config_contas_omie',
    '/Planejamento_orcamentario',
    '/Reunioes',
    '/ListaReunioes',
    '/configuracao-calendario',
    '/Contabil-reunioes',
    '/Analise-op-memora',
    '/analise-op-memora',
    '/analise-gestor-memora',
    '/analise-clientes-memora',
    '/oportunidades-memora',
    '/memora-riscos',
    '/memora-intelligence',
    '/memora-documentacao',
    '/auditoria-balancete',
    '/auditoria-resultado',
    '/historico-auditoria',
    '/HistoricoEnvioLucrosSocios',
    '/admin/usuarios',
    '/admin/atualizacoes',
    '/admin/logs',
    '/admin/webhook-eventos',
    '/admin/stripe-eventos',
    '/admin/cargas-banco',
    '/admin/api-bporh',
    '/admin/sync-convenia',
    '/Admin/MemoraContestacoes',
    '/admin/custos-gcp',
  ];
  
  // Verifica rotas estáticas e dinâmicas (como /dashboard-cliente/:id)
  const isHeaderHidden = hideHeaderRoutes.includes(location.pathname) || 
                         location.pathname.startsWith('/dashboard-cliente/') || 
                         location.pathname.startsWith('/Apagar_cliente/') || 
                         location.pathname.startsWith('/Receber_cliente/') ||
                         location.pathname.startsWith('/Posicao_cliente/') ||
                         location.pathname.startsWith('/Posicao_cliente_conta_azul/') ||
                         location.pathname.startsWith('/Posicao_dia/') ||
                         location.pathname.startsWith('/Fechamento_cliente/') ||
                         location.pathname.startsWith('/EnvioNotas_cliente/') ||
                         location.pathname.startsWith('/Projetos_cliente/') ||
                         location.pathname.startsWith('/dashboard-conta-azul/') ||
                         location.pathname.startsWith('/Config_contas_omie/') ||
                         location.pathname.startsWith('/Planejamento_orcamentario/') ||
                         location.pathname.startsWith('/Saving_cliente/') ||
                         location.pathname.startsWith('/Dre_horizontal/') ||
                         location.pathname.startsWith('/Dre_vertical/') ||
                         location.pathname.startsWith('/Orcamento_despesas/') ||
                         location.pathname.startsWith('/Orcamento_receitas/') ||
                         location.pathname.startsWith('/portal-cliente') ||
                         location.pathname.startsWith('/BpoRh/') ||
                         location.pathname.startsWith('/Fiscal/') ||
                         location.pathname.startsWith('/Dp/') ||
                         location.pathname.startsWith('/RelatorioInvestidores/')


  return (
    <div style={{ display: 'flex' }}>
      <ToastContainer position="top-right" autoClose={3000} newestOnTop pauseOnHover theme="light" />
      {!fullBleed && <Sidebar />}
      <div
        className="layout-main-content"
        style={{
          marginLeft: fullBleed ? '0' : '6rem',
          padding: fullBleed ? '0' : '2rem',
          flex: 1,
          minWidth: 0,
          maxWidth: fullBleed ? '100%' : 'calc(100% - 6rem)',
          overflowX: 'hidden',
        }}
      >
        {!isHeaderHidden && <Header />}
        {children}
        <AtualizacoesModal />
        {/* BPO RH: em qualquer tela do módulo, cobra a causa dos atrasos da carteira
            (a chave muda ao sair/voltar do módulo, então ele checa de novo na volta) */}
        {/^\/(BpoRh|Dp)/i.test(decodeURIComponent(location.pathname)) && <ModalAtrasosRh key="bporh" />}
        {/* devolução da gestora numa finalização manual: orientação para a operadora */}
        {/^\/(BpoRh|Dp)/i.test(decodeURIComponent(location.pathname)) && <ModalFinalizacaoDevolvida key="bporh-dev" />}
      </div>
    </div>
  );
};

function App() {
  // Interceptor global: em caso de 401 (token expirado), renova o access token com o
  // refresh token e refaz a requisição automaticamente — evita perder dados ao salvar.
  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const original = error.config;
        const status = error.response && error.response.status;
        if (
          status === 401 &&
          original &&
          !original._retry &&
          !String(original.url || '').includes('/api/token/refresh/')
        ) {
          original._retry = true;
          const refresh = localStorage.getItem('refresh');
          if (!refresh) {
            window.location.href = '/login';
            return Promise.reject(error);
          }
          try {
            const resp = await axios.post(`${process.env.REACT_APP_API_BASE}/api/token/refresh/`, { refresh });
            if (resp.data && resp.data.access) {
              localStorage.setItem('access', resp.data.access);
              if (resp.data.refresh) localStorage.setItem('refresh', resp.data.refresh);
              original.headers = original.headers || {};
              original.headers['Authorization'] = `Bearer ${resp.data.access}`;
              return axios(original);
            }
          } catch (e) {
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            window.location.href = '/login';
          }
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptorId);
  }, []);

  useEffect(() => {
    const interval = setInterval(async () => {
      const refreshToken = localStorage.getItem('refresh');

      if (!refreshToken) return;

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE}/api/token/refresh/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh: refreshToken }),
        });

        if (!response.ok) {
          console.warn(`Falha ao renovar token (status: ${response.status})`);
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          window.location.href = '/login';
          return;
        }

        const data = await response.json();
        if (data.access) {
          localStorage.setItem('access', data.access);
          console.log('Token renovado automaticamente');
        }
      } catch (error) {
        console.error('Erro ao tentar renovar token:', error);
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        window.location.href = '/login';
      }
    }, 8 * 60 * 60 * 1000); // 8 horas

    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <TempoAtivoProvider>
      <LayoutWrapper>
        <Routes>
          {/* ===================================
              ROTAS PÚBLICAS
              =================================== */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/fmp" element={<FmpLanding />} />
          <Route path="/admissao" element={<SolicitacaoAdmissao />} />
          <Route path="/desligamento" element={<SolicitacaoDesligamento />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/acesso-negado" element={<AcessoNegado />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />

          {/* ===================================
              ROTAS PARA CLIENTES
              (Valida id_bpo com cliente_id da URL)
              =================================== */}
          <Route element={<ClienteRoute />}>
            <Route path="/dashboard-cliente/:cliente_id" element={<ClienteRestritoRoute element={<DashboardCliente />} />} />
            <Route path="/Apagar_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_contas_pagar" element={<Apagar_cliente />} />} />} />
            <Route path="/Receber_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_contas_receber" element={<Receber_cliente />} />} />} />
            <Route path="/Posicao_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_posicao" element={<Posicao_cliente />} />} />} />
            <Route path="/Posicao_dia/:cliente_id" element={<ClienteRestritoRoute element={<Posicao_dia />} />} />
            <Route path="/Fechamento_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_fechamento" element={<Fechamento_cliente />} />} />} />
            <Route path="/EnvioNotas_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_envio_notas" element={<EnvioNotas_cliente />} />} />} />
            <Route path="/Projetos_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_projetos" element={<Projetos_cliente />} />} />} />
            <Route path="/dashboard-conta-azul/:cliente_id" element={<ClienteRestritoRoute element={<DashboardContaAzul />} />} />
            <Route path="/assistente-financeiro/:cliente_id" element={<ClienteRestritoRoute element={<AssistenteFinanceiroCliente />} />} />
            <Route path="/Posicao_cliente_conta_azul/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_posicao" element={<Posicao_cliente />} />} />} />
            <Route path="/Config_contas_omie/:cliente_id" element={<ClienteRestritoRoute element={<Config_contas_omie />} />} />
            <Route path="/Planejamento_orcamentario/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_projecao_orcamentaria" element={<PlanejamentoCliente />} />} />} />
            <Route path="/Saving_cliente/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_saving" element={<SavingCliente />} />} />} />
            <Route path="/Dre_horizontal/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_dre_horizontal" element={<DreHorizontal />} />} />} />
            <Route path="/Dre_vertical/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_dre_vertical" element={<DreVertical />} />} />} />
            <Route path="/Orcamento_despesas/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_projecao_orcamentaria" element={<OrcamentoCadastro tipo="despesas" />} />} />} />
            <Route path="/Orcamento_receitas/:cliente_id" element={<ClienteRestritoRoute element={<ModuloRoute modulo="mod_projecao_orcamentaria" element={<OrcamentoCadastro tipo="receitas" />} />} />} />
          </Route>

          {/* ===================================
              ROTAS EXCLUSIVAS PARA FUNCIONÁRIOS
              (id_bpo === 0 ou null)
              =================================== */}
          <Route element={<PrivateRoute />}>
            <Route path="/home" element={<Home />} />
            <Route path="/kanban" element={<Kanban />} />
            <Route path="/tarefas" element={<Tarefas />} />
            <Route path="/IntegraContador" element={<IntegraContador />} />
            <Route path="/Dctfweb" element={<Dctfweb />} />
            <Route path="/Fiscal/Base" element={<FiscalGuard><FiscalBase /></FiscalGuard>} />
            <Route path="/Fiscal/Certificados" element={<FiscalGuard><FiscalCertificados /></FiscalGuard>} />
            <Route path="/Fiscal/Configuracoes" element={<FiscalGuard><FiscalConfiguracoes /></FiscalGuard>} />
            <Route path="/Fiscal/Monitor" element={<FiscalGuard><FiscalMonitor /></FiscalGuard>} />
            <Route path="/Fiscal/Usuarios" element={<FiscalGuard><FiscalUsuarios /></FiscalGuard>} />
            <Route path="/Fiscal/ComoUsar" element={<FiscalGuard><FiscalDocumentacao /></FiscalGuard>} />
            <Route path="/Fiscal/Painel" element={<FiscalGuard><FiscalPainel /></FiscalGuard>} />
            <Route path="/Fiscal/Fechamento" element={<FiscalGuard><FiscalFechamento /></FiscalGuard>} />
            <Route path="/Fiscal/ConsultaChave" element={<FiscalGuard><FiscalConsultaChave /></FiscalGuard>} />
            <Route path="/Fiscal/Faturamento" element={<FiscalGuard><FiscalFaturamento /></FiscalGuard>} />
            <Route path="/Fiscal/Entregas" element={<FiscalGuard><FiscalEntregas /></FiscalGuard>} />
            <Route path="/Fiscal/Tarefas" element={<FiscalGuard><FiscalTarefas /></FiscalGuard>} />
            <Route path="/Fiscal/TarefasAcessorias" element={<FiscalGuard><FiscalTarefasAcessorias /></FiscalGuard>} />
            <Route path="/Fiscal/CaixaPostal" element={<FiscalGuard><FiscalCaixaPostal /></FiscalGuard>} />
            <Route path="/Fiscal/RegimeApuracao" element={<FiscalGuard><FiscalRegime /></FiscalGuard>} />
            <Route path="/Dividas" element={<Dividas />} />
            <Route path="/Das" element={<Das />} />
            <Route path="/Enviaremaildp" element={<Enviaremaildp />} />
            <Route path="/BpoRhClientes" element={<BpoRhClientes />} />
            <Route path="/BpoRhClientesCadastro" element={<BpoRhClientesCadastro />} />
            <Route path="/BpoRhColaboradores" element={<BpoRhColaboradores />} />
            {/* rota mais específica vence a genérica /BpoRh/:categoria */}
            <Route path="/BpoRh/Ponto/cliente/:clienteId" element={<BpoRhPonto />} />
            <Route path="/BpoRh/Beneficios/cliente/:clienteId" element={<BpoRhBeneficios />} />
            <Route path="/BpoRh/ControleBeneficios" element={<BpoRhBeneficios />} />
            {/* mesma tela, outro benefício: o tipo decide valores, base de dias
                e layout do arquivo (tudo separado do VA no banco) */}
            <Route path="/BpoRh/HomeOffice" element={<BpoRhBeneficios tipo="home_office" />} />
            <Route path="/BpoRh/HomeOffice/cliente/:clienteId"
              element={<BpoRhBeneficios tipo="home_office" />} />
            <Route path="/BpoRh/ValeTransporte/cliente/:clienteId" element={<BpoRhValeTransporte />} />
            <Route path="/BpoRh/ValeTransporte" element={<BpoRhValeTransporte />} />
            <Route path="/BpoRh/FechamentoPonto" element={<FechamentoPonto />} />
            <Route path="/BpoRh/Conversas" element={<BpoRhConversas />} />
            <Route path="/BpoRh/PainelOperador" element={<PainelOperador />} />
            <Route path="/BpoRh/Gestao" element={<GestaoBpoRh />} />
            <Route path="/BpoRh/FechamentoCliente" element={<BpoRhFechamentoCliente />} />
            <Route path="/BpoRh/Financeiro" element={<BpoRhFinanceiro />} />
            <Route path="/BpoRh/Dissidio" element={<BpoRhDissidio />} />
            <Route path="/BpoRh/AgenteRh" element={<BpoRhAgenteRh />} />
            <Route path="/BpoRh/Curriculos" element={<BpoRhCurriculos />} />
            <Route path="/BpoRh/AjusteSalario" element={<BpoRhAjusteSalario />} />
            <Route path="/BpoRh/ImportacaoOmie" element={<BpoRhImportacaoOmie />} />
            <Route path="/BpoRh/Adiantamento" element={<BpoRhAdiantamento />} />
            <Route path="/BpoRh/ResumoCentroCusto" element={<BpoRhLiquidosCC />} />
            <Route path="/BpoRh/ControleFolgas" element={<BpoRhControleFolgas />} />
            <Route path="/BpoRh/PlanoSaude" element={<BpoRhPlanoSaude />} />
            <Route path="/BpoRh/CustoColaborador" element={<BpoRhCustoColaborador />} />
            <Route path="/BpoRh/Operadores" element={<BpoRhOperadores />} />
            <Route path="/BpoRh/Documentacao" element={<BpoRhDocumentacao />} />
            <Route path="/BpoRh/:categoria" element={<BpoRhClientes />} />
            <Route path="/Dp/Admissões" element={<BpoRhAdmissoes />} />
            <Route path="/BpoRhAtividadesAdmissao" element={<BpoRhAtividadesAdmissao />} />
            <Route path="/BpoTarefas/:area" element={<BpoTarefasMensais />} />
            <Route path="/Dp/Rescisões" element={<BpoRhRescisoes />} />
            <Route path="/Dp/Férias" element={<BpoRhFerias />} />
            <Route path="/Dp/Prorrogação Colaborador" element={<BpoRhProrrogacao />} />
            <Route path="/Dp/Controle de Estágio" element={<BpoRhEstagio />} />
            {/* NR-7: a rota mantém o nome que já estava no menu */}
            <Route path="/Dp/Exame Mensal" element={<BpoRhExamePeriodico />} />
            <Route path="/Dp/Sindicatos" element={<BpoRhSindicatos />} />
            {/* folha: lista por cliente e, com o cliente, a folha dele */}
            <Route path="/Dp/Folha de Pagamento" element={<BpoRhFolha />} />
            <Route path="/BpoRh/Folha/cliente/:clienteId" element={<BpoRhFolha />} />
            <Route path="/Dp/:atividade" element={<DpAtividade />} />
            <Route path="/Contabilidade" element={<Contabilidade />} />
            <Route path="/portal-cliente" element={<PortalCliente />} />
            <Route path="/portal-cliente/:tipo/:valor" element={<PortalCliente />} />
            <Route path="/portal-cliente/:numero_dominio" element={<PortalCliente />} />
            <Route path="/Textolivre" element={<Textolivre />} />
            <Route path="/CadastrarCliente" element={<CadastrarCliente />} />
            <Route path="/relatorio-fiscal" element={<RelatorioFiscal />} />
            <Route path="/Pgfn" element={<Pgfn />} />
            <Route path="/Guia-fgts" element={<Fgts />} />
            <Route path="/Comprovante-ECAC" element={<Comprovante />} />
            <Route path="/Logados" element={<Logados />} />
            <Route path="/Checklist" element={<Checklist />} />
            <Route path="/Contagemcontabilidade" element={<Contagemcontabilidade />} />
            <Route path="/Pendenciacontabil" element={<Pendenciacontabil />} />
            <Route path="/Contabilidade/Operacional" element={<PainelOperacionalContabil />} />
            <Route path="/Bpo" element={<Bpo />} />
            <Route path="/GestaoBpo" element={<GestaoBpo />} />
            <Route path="/BpoFin/ConciliacaoOmie" element={<BpoFinConciliacaoOmie />} />
            <Route path="/BpoFin/CartaoPixCards" element={<BpoFinCartaoPixCards />} />
            <Route path="/BpoFin/ConciliacaoVendizap" element={<BpoFinConciliacaoVendizap />} />
            <Route path="/BpoFin/ConciliacaoAsaasVendizap" element={<BpoFinConciliacaoAsaasVendizap />} />
            <Route path="/Outboardingcontabil" element={<Outboardingcontabil />} />
            <Route path="/Relatorio_contabil" element={<Relatorio_contabil />} />
            <Route path="/RevisaoRelatorios" element={<RevisaoRelatorios />} />
            <Route path="/Gestao_contabil" element={<Gestao_contabil />} />
            <Route path="/Atrasoatual" element={<Atrasoatual />} />
            <Route path="/Devedores" element={<Devedores />} />
            <Route path="/Impostos-recup" element={<Impostos_recup />} />
            <Route path="/CarteiraContabil" element={<CarteiraContabil />} />
            <Route path="/Admconsultas" element={<Admconsultas />} />
            <Route path="/SpedContabil" element={<SpedContabil />} />
            <Route path="/Contabil-reunioes" element={<Contabil_reunioes />} />
            <Route path="/Reunioes" element={<Reunioes />} />
            <Route path='/auditoria-balancete' element={<Auditoria_balancete />} />
            <Route path='/auditoria-resultado' element={<Auditoria_resultado />} />
            <Route path='/historico-auditoria' element={<Historico_auditoria />} />
            <Route path='/HistoricoEnvioLucrosSocios' element={<HistoricoEnvioLucrosSocios />} />


            
            {/* Rotas do MEMORA.IA — protegidas: exigem memora_ia = 'sim' na auth_user */}
            <Route path="/ListaReunioes" element={<MemoraGuard><ListaReunioes /></MemoraGuard>} />
            <Route path="/configuracao-calendario" element={<MemoraGuard><ConfiguracaoCalendario /></MemoraGuard>} />
            <Route path="/Analise-op-memora" element={<MemoraGuard><Analise_op_memora /></MemoraGuard>} />
            <Route path="/analise-gestor-memora" element={<MemoraGuard adminOnly><Analise_gestor_memora /></MemoraGuard>} />
            <Route path="/analise-clientes-memora" element={<MemoraGuard adminOnly><MemoraAnaliseClientes /></MemoraGuard>} />
            <Route path="/oportunidades-memora" element={<MemoraGuard grupos={['adm', 'comercial']}><Oportunidades_memora /></MemoraGuard>} />
            <Route path="/memora-riscos" element={<MemoraGuard adminOnly><Memora_riscos /></MemoraGuard>} />
            <Route path="/memora-intelligence" element={<MemoraGuard adminOnly><Memora_intelligenc /></MemoraGuard>} />
            <Route path="/memora-documentacao" element={<MemoraGuard semMascote><Memora_documentacao /></MemoraGuard>} />

            <Route path="/admin/usuarios" element={<CadastrarUsuario />} />
            <Route path="/admin/atualizacoes" element={<AdminAtualizacoes />} />
            <Route path="/admin/logs" element={<AdminLogs />} />
            <Route path="/admin/webhook-eventos" element={<WebhookEventos />} />
            <Route path="/admin/stripe-eventos" element={<StripeEventos />} />
            <Route path="/admin/custos-gcp" element={<AdminCustosGcp />} />
            <Route path="/admin/cargas-banco" element={<CargasBanco />} />
            <Route path="/admin/api-bporh" element={<ApiOcorrencias />} />
            <Route path="/admin/sync-convenia" element={<SyncConvenia />} />
            <Route path="/admin/copiar-banco" element={<CopiaBanco />} />
            <Route path="/Admin/MemoraContestacoes" element={<MemoraGuard adminOnly><MemoraContestacoes /></MemoraGuard>} />
            <Route path="/RelatorioInvestidores/:clienteId" element={<RelatorioInvestidores />} />

          </Route>
        </Routes>
      </LayoutWrapper>
      {/* widget do tempo BPO: segue o usuário em qualquer página enquanto
          houver relógio correndo (empresa ligada ou tarefa cronometrada) */}
      <TempoFlutuante />
      </TempoAtivoProvider>
    </Router>
  );
}

export default App;